<template>
  <div class="StdTable">
    <table class="StdTable__table">
      <tr class="StdTable__row" v-for="(row, rowIndex) in content" v-bind:key="rowIndex">
        <TableCell
          v-for="(cell, cellIndex) in row" 
          :heading="cell.heading"
          :content="cell.text" 
          :rowspan="cell.rowspan"
          :colspan="cell.colspan"
          v-bind:key="cellIndex"
        />
      </tr>
    </table>
  </div>
</template>

<script>
import { StdButton } from './../StdButton'
import { TableCell } from './../TableCell'
export default {
  components: {
    StdButton,
    TableCell,
  },
  props: {
    identifier: {
      type: Number,
      default: 0
    },
    content: {
      type: Array,
      default: () => []
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  methods: {
    onEdit() {
      this.$store.commit('SET_TABLE_TO_EDIT', { identifier: this.identifier, content: this.content })
    },
    onDeleteTable() {
      this.$store.commit('REMOVE_CHAPTER_CONTENT', this.identifier)
    },
  }
}
</script>

<style scoped>
.StdTable {
  margin-bottom: 26px;
  overflow-x: scroll;
  position: relative;
}

.StdTable__table {
  border: 1px solid #bed1c7;
  border-collapse: collapse;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/StdTable/StdTable.vue